export const addSpaceForCardNumber = (input: string | number): string => {
    const inputString = String(input); // Convert input to string

    if (!inputString || inputString.length <= 4) {
        return inputString; // No need to add space if the length is less than or equal to 4
    }

    let result = '';
    for (let i = 0; i < inputString.length; i++) {
        result += inputString[i];
        if ((i + 1) % 4 === 0 && i !== inputString.length - 1) {
            result += ' '; // Add space after every 4 characters, excluding the last character
        }
    }

    return result;
};
